import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import mapboxgl from "mapbox-gl";

export default class MapSearchControl implements mapboxgl.IControl {
	private map: mapboxgl.Map;
	private container: HTMLDivElement;
	private geoCoder: MapboxGeocoder;

	constructor(latitude: number, longitude: number) {
		const mapboxApiKey = process.env.MAPBOX_API_KEY;
		const geoCoder = new MapboxGeocoder({
			accessToken: mapboxApiKey,
			mapboxgl,
			flyTo: true,
			collapsed: true,
			trackProximity: true,
			proximity: { latitude: latitude, longitude: longitude },
		});

		this.geoCoder = geoCoder;
	}

	onAdd(map: mapboxgl.Map) {
		this.map = map;
		this.container = document.createElement("div");
		this.container.className = "mapboxgl-ctrl-search";
		this.container.appendChild(this.geoCoder.onAdd(this.map));

		return this.container;
	}

	onRemove() {
		this.container.parentNode.removeChild(this.container);
		this.map = undefined;
	}
}
